<template>
  <div class="right_cont">
    <el-breadcrumb
      v-if="isNavigate"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">
        {{ $t('breadcrumb.home') }}
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'automation' }">
        {{ $t('breadcrumb.ifttt') }}
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'iftttCustomSet' }">
        {{ $t('breadcrumb.iftttCustomSet') }}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div
      class="out_bread"
      :class="{ 'disable-interactive': isCantEdit }"
      :style="isNavigate?'':'top:0;border:none;'"
    >
      <div class="customset">
        <vuescroll @handle-scroll="() => {}">
          <div class="blue_border margin32">
            {{ $t('iftttset.baseinfor') }}
          </div>
          <div class="custom_base">
            <span>{{ $t('iftttset.basename') }}：</span>
            <input
              v-model="name"
              maxlength="32"
            >
          </div>
          <template v-if="isTriggle || isAction || isSchedule">
            <div class="blue_border margin32">
              {{ $t('iftttset.automationset') }}
            </div>
            <div
              class="custom_border"
              style="margin-bottom: 90px;"
            >
              <div
                v-if="isTriggle"
                class="custom_line clearfix"
              >
                <div class="custom_left">
                  <span class="dot_num">1</span>
                  {{ $t('iftttset.if') }}
                </div>
                <div class="custom_right custom_set">
                  <div 
                    v-if="!isRegularTriggle"
                    class="custom_right_line"
                  >
                    <el-radio-group
                      v-for="(item, index) in optionsAdd4"
                      :key="index"
                      v-model="TRI_Relation"
                    >
                      <el-radio :label="item.value">
                        {{ item.label }}
                      </el-radio><br>
                    </el-radio-group>
                  </div>
                  <div
                    v-for="(item, index) in timeOption"
                    :key="'info-' + index"
                    class="custom_right_line clearfix"
                  >
                    <span>{{ index + 1 }}</span>
                    <em />
                    <span>{{ $t('iftttset.timing') }} {{ item }}</span>

                    <el-button
                      type="text"
                      class="ifttt_mod_button"
                      @click="modifyTriggerTime(item)"
                    >
                      <i class="icon-21" />
                    </el-button>
                    <el-button
                      type="text"
                      class="ifttt_del_button"
                      @click="delTime(index)"
                    >
                      <i class="icon--1" />
                    </el-button>
                  </div>

                  <div
                    v-if="sunOption"
                    class="custom_right_line clearfix"
                  >
                    <span>{{ timeOption.length + 1 }}</span>
                    <em />
                    <span>{{ sunOption.Label }}</span>

                    <el-button
                      type="text"
                      class="ifttt_mod_button"
                      @click="modifySun"
                    >
                      <i class="icon-21" />
                    </el-button>
                    <el-button
                      type="text"
                      class="ifttt_del_button"
                      @click="delSun"
                    >
                      <i class="icon--1" />
                    </el-button>
                  </div>

                  <div
                    v-for="(item, index) in deviceOption"
                    :key="'info1-' + index"
                    class="custom_right_line clearfix"
                  >
                    <div class="clearfix">
                      <span>{{ timeOption.length + (sunOption ? 1 : 0) + index + 1 }}</span>
                      <em />
                      <span>{{ item.DeviceName }}
                        <template v-if="item.IsDel == true && item.IsInOtherArea != true">{{ '-'+$t('iftttset.alreadydelete') }}</template>
                        <template v-else-if="item.IsDel == true && item.IsInOtherArea == true">{{ '-'+$t('iftttset.alreadymove') }}</template>
                      </span>
                    </div>
                    <div
                      v-if="item.triggle != null && item.IsDel != true"
                      class="add_line"
                    >
                      <div class="triggle_line clearfix">
                        <span class="triggle_span">{{ item.triggle.Desc }}</span>
                        <div class="triggle_left">
                          <div
                            v-if="item.triggle.ValueType == 'UIControl_Switch'"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <el-switch
                                  v-model="item.triggle.DefaultValue"
                                  active-color="#7dacee"
                                  inactive-color="#d9e2f0"
                                  :active-value="1"
                                  :inactive-value="0"
                                />
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="item.triggle.ValueType == 'UIControl_Slider' && item.triggle.OperationValue !== 8"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <div class="triggle_no_img">
                                  <div class="triggle_slider pr_6">
                                    <el-slider
                                      v-model="item.triggle.DefaultValue"
                                      :min="item.triggle.Min"
                                      :max="item.triggle.Max"
                                    />
                                  </div>
                                  <el-input-number
                                    v-model="item.triggle.DefaultValue"
                                    class="input_number_action"
                                    :min="item.triggle.Min"
                                    :max="item.triggle.Max"
                                    style="width: 50px;height:24px;"
                                  />
                                  <span
                                    v-if="item.triggle.ParaUnit"
                                    class="triggle_para_unit"
                                  >{{ item.triggle.ParaUnit }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="item.triggle.ValueType == 'UIControl_Slider' && item.triggle.OperationValue === 8"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">&lt;</span>
                              <div class="triggle_div2">
                                <div class="triggle_no_img">
                                  <div class="triggle_slider pr_6">
                                    <el-slider
                                      v-model="item.triggle.DefaultValue[0]"
                                      :min="item.triggle.Min"
                                      :max="item.triggle.DefaultValue[1]"
                                    />
                                  </div>
                                  <el-input-number
                                    v-model="item.triggle.DefaultValue[0]"
                                    class="input_number_action"
                                    :min="item.triggle.Min"
                                    :max="item.triggle.DefaultValue[1]"
                                    style="width: 50px;height:24px;"
                                  />
                                  <span
                                    v-if="item.triggle.ParaUnit"
                                    class="triggle_para_unit"
                                  >{{ item.triggle.ParaUnit }}</span>
                                </div>
                              </div>
                              <span class="triggle_span2 triggle_span_middle">{{ $t('iftttset.or') }} ></span>
                              <div class="triggle_div2">
                                <div class="triggle_no_img">
                                  <div class="triggle_slider pr_6">
                                    <el-slider
                                      v-model="item.triggle.DefaultValue[1]"
                                      :min="item.triggle.DefaultValue[0]"
                                      :max="item.triggle.Max"
                                    />
                                  </div>
                                  <el-input-number
                                    v-model="item.triggle.DefaultValue[1]"
                                    class="input_number_action"
                                    :min="item.triggle.DefaultValue[0]"
                                    :max="item.triggle.Max"
                                    style="width: 50px;height:24px;"
                                  />
                                  <span
                                    v-if="item.triggle.ParaUnit"
                                    class="triggle_para_unit"
                                  >{{ item.triggle.ParaUnit }}</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="item.triggle.ValueType == 'UIControl_DropdownList'"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <el-select
                                  v-model="item.triggle.DefaultValue"
                                  class="input_set"
                                >
                                  <el-option
                                    v-for="(smodel, i) in item.triggle.EnumValue"
                                    :key="'Ctriggerdrop' + smodel.Value"
                                    :label="smodel.Name"
                                    :value="smodel.Value"
                                  />
                                </el-select>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="item.triggle.ValueType == 'UIControl_ColorTemperature'"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <img
                                  class="triggle_img1"
                                  src="../../assets/img/icon_set-01.png"
                                >
                                <div class="triggle_slider triggle_have_img">
                                  <el-slider
                                    v-model="item.triggle.DefaultValue"
                                    :min="item.triggle.Min"
                                    :max="item.triggle.Max"
                                    class="color_add"
                                  />
                                </div>
                                <img
                                  class="triggle_img2"
                                  src="../../assets/img/icon_set-02.png"
                                >
                                <el-input-number
                                  v-model="item.triggle.DefaultValue"
                                  class="input_number_action"
                                  :min="item.triggle.Min"
                                  :max="item.triggle.Max"
                                  style="width: 50px;height:24px;"
                                />
                                <span
                                  v-if="item.triggle.ParaUnit"
                                  class="triggle_para_unit"
                                >{{ item.triggle.ParaUnit }}</span>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="item.triggle.ValueType == 'UIControl_Bright'"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <img
                                  class="triggle_img1"
                                  src="../../assets/img/icon_set-03.png"
                                >
                                <div class="triggle_slider triggle_have_img">
                                  <el-slider
                                    v-model="item.triggle.DefaultValue"
                                    :min="item.triggle.Min"
                                    :max="item.triggle.Max"
                                    class="light_add"
                                  />
                                </div>
                                <img
                                  class="triggle_img2"
                                  src="../../assets/img/icon_set-04.png"
                                >
                                <el-input-number
                                  v-model="item.triggle.DefaultValue"
                                  class="input_number_action"
                                  :min="item.triggle.Min"
                                  :max="item.triggle.Max"
                                  style="width: 50px;height:24px;"
                                />
                                <span
                                  v-if="item.triggle.ParaUnit"
                                  class="triggle_para_unit"
                                >{{ item.triggle.ParaUnit }}</span>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="item.triggle.ValueType == 'UIControl_SliderAndInput'"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <div class=" triggle_have_input">
                                  <div class="triggle_slider ">
                                    <el-slider
                                      v-model="item.triggle.DefaultValue"
                                      :min="item.triggle.Min"
                                      :max="item.triggle.Max"
                                      show-input
                                    />
                                  </div>
                                  <span
                                    v-if="item.triggle.ParaUnit"
                                    class="triggle_para_unit"
                                  >{{ item.triggle.ParaUnit }}</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="item.triggle.ValueType == 'UIControl_MultipleDropdownList'"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <el-select
                                  v-model="item.triggle.DefaultValue"
                                  class="input_set"
                                  multiple
                                  collapse-tags
                                >
                                  <el-option
                                    v-for="(smodel) in item.triggle.EnumValue"
                                    :key="'Ctriggerdrop' + smodel.Value"
                                    :label="smodel.Name"
                                    :value="smodel.Value"
                                  />
                                </el-select>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="item.triggle.ValueType == 'UIControl_RadioboxList'"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <el-radio
                                  v-for="(smodel) in item.triggle.EnumValue"
                                  :key="'Dt' + smodel.Value"
                                  v-model="item.triggle.DefaultValue"
                                  :label="smodel.Value"
                                >
                                  {{ smodel.Name }}
                                </el-radio>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="item.triggle.ValueType == 'UIControl_CheckboxList'"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <el-checkbox-group v-model="item.triggle.DefaultValue">
                                  <el-checkbox
                                    v-for="(smodel) in item.triggle.EnumValue"
                                    :key="'Fxt' + smodel.Value"
                                    :label="smodel.Value"
                                  >
                                    {{ smodel.Name }}
                                  </el-checkbox>
                                </el-checkbox-group>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="item.triggle.ValueType == 'UIControl_Input'"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <input
                                  v-model="item.triggle.DefaultValue"
                                  class="triggle_input_set"
                                >
                                <span
                                  v-if="item.triggle.ParaUnit"
                                  class="triggle_para_unit"
                                >{{ item.triggle.ParaUnit }}</span>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="item.triggle.ValueType == 'UIControl_ChooseRange'"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <div class="triggle_no_img">
                                  <div class="triggle_slider">
                                    <el-slider
                                      v-model="item.triggle.DefaultValue"
                                      :min="item.triggle.Min"
                                      range
                                      :max="item.triggle.Max"
                                    />
                                  </div>
                                  <span class="triggle_input">{{ item.triggle.DefaultValue[0] }}-{{ item.triggle.DefaultValue[1] }}</span>
                                  <span
                                    v-if="item.triggle.ParaUnit"
                                    class="triggle_para_unit"
                                  >{{ item.triggle.ParaUnit }}</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="item.triggle.ValueType == ' UIControl_MotorTrace_Slider' || item.ValueType == 'UIControl_MotorVerticalTrace_Slider'"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <img
                                  class="triggle_img1"
                                  src="../../assets/img/icon_set-06.png"
                                >
                                <div class="triggle_slider triggle_have_img">
                                  <el-slider
                                    v-model="item.triggle.DefaultValue"
                                    :min="item.triggle.Min"
                                    :max="item.triggle.Max"
                                  />
                                </div>
                                <img
                                  class="triggle_img2"
                                  src="../../assets/img/icon_set-05.png"
                                >
                                <span class="triggle_input">{{ item.triggle.DefaultValue }}%</span>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="item.triggle.ValueType == ' UIControl_MotorAngle_Slider'"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <img
                                  class="triggle_img1"
                                  src="../../assets/img/icon_set-07.png"
                                >
                                <div class="triggle_slider triggle_have_img">
                                  <el-slider
                                    v-model="item.triggle.DefaultValue"
                                    :min="item.triggle.Min"
                                    :max="item.triggle.Max"
                                  />
                                  <span class="angle_span1">{{ $t('iftttset.up') }}</span>
                                  <span class="angle_span2">{{ $t('iftttset.down') }}</span>
                                </div>
                                <img
                                  class="triggle_img2"
                                  src="../../assets/img/icon_set-08.png"
                                >
                                <span class="triggle_input">{{ item.triggle.DefaultValue }}°</span>
                              </div>
                            </div>
                          </div>

                          <!-- 有异议 -->
                          <div
                            v-if="item.triggle.ValueType == 'UIControl_StartAndStop'"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <button class="warm_button warm_button_left statr_button">
                                  <i class="icon-141" />
                                  {{ $t('deviceMsg.stop') }}
                                </button>
                                <button class="warm_button statr_button">
                                  <i class="icon-10" />
                                  {{ $t('deviceMsg.star') }}
                                </button>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="item.triggle.ValueType == 'UIControl_Motor_Stop'"
                            class="triggle_div"
                          >
                            <div class="triggle_ctr ">
                              <span class="triggle_span2">{{ item.triggle.OperationName }}</span>
                              <div class="triggle_div2">
                                <button class="warm_button warm_button_left statr_button">
                                  <i class="icon-141" />
                                  {{ $t('deviceMsg.stop') }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <el-button
                      type="text"
                      class="ifttt_mod_button"
                      @click="modifyCanMultipleSelect(item)"
                    >
                      <i class="icon-21" />
                    </el-button>
                    <el-button
                      v-if="!isInnoTrigger"
                      type="text"
                      class="ifttt_del_button"
                      @click="delDevice(item, index)"
                    >
                      <i class="icon--1" />
                    </el-button>
                  </div>
                  <div
                    v-for="(item, index) in triggermanual"
                    :key="'infomanual-' + index"
                    class="custom_right_line clearfix"
                  >
                    <em />
                    <span>{{ $t('iftttset.handledo') }} {{ item.name }}</span>
                    <!-- <i class="icon--1" ></i> -->
                    <el-button
                      type="text"
                      class="ifttt_del_button"
                      :disabled="iftttmodel!=null"
                      @click="delmanualTrigger(item, index)"
                    >
                      <i class="icon--1" />
                    </el-button>
                  </div>

                  <el-dropdown
                    v-if="triggerObjAdddataShow() && triggermanual.length==0 && !isRegularTriggle"
                    trigger="click"
                    class="dialog_add text-button"
                    @command="handleAdd2"
                  >
                    <span class="el-dropdown-link">
                      {{ $t('iftttset.adddata') }}
                      <i class="el-icon-arrow-down el-icon--right" />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(item, index) in triggerTypeList"
                        :key="'info2-' + index"
                        :disabled="item.disabled"
                        :command="item.value"
                      >
                        {{ item.label }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <span
                    v-if="triggerObjAdddataShow()!=true"
                    class="warmfont warmTips"
                  >{{ triggerObjAdddataShowTips() }}</span>
                </div>
              </div>

              <div
                v-if="isAction"
                class="custom_line clearfix"
              >
                <div class="custom_left">
                  <span class="dot_num">{{ isTriggle?2:1 }}</span>
                  {{ $t('iftttset.do') }}
                </div>
                <div class="custom_right">
                  <template v-for="(action, index) in allactionlist">
                    <template v-if="action.ActionType==0">
                      <div
                        :key="'infoaction-' + index"
                        class="custom_right_line clearfix"
                      >
                        <div class="triggle_block clearfix">
                          <div class="triggle_left">
                            <div
                              class="triggle_title"
                              style="overflow: unset;"
                            >
                              <span>{{ index + 1 }}</span>
                              <em />
                              {{ $t('iftttset.do1') }} {{ action.ChannelName && action.ChannelName!="" ? action.ChannelName+'-':'' }} {{ action.DeviceName }}
                              <template v-if="action.IsDel == true && action.IsInOtherArea != true">
                                {{ '-'+$t('iftttset.alreadydelete') }}
                              </template>
                              <template v-else-if="action.IsDel == true && action.IsInOtherArea == true">
                                {{ '-'+$t('iftttset.alreadymove') }}
                              </template>
                              <template>{{ 'Action' }}</template>
                            </div>
                            <span class="button_remove">
                              <el-button
                                :disabled="index==0"
                                @click="upmove(index)"
                              >{{ $t('iftttset.upmove') }}</el-button>
                              <el-button
                                :disabled="index+1==allactionlist.length"
                                @click="downmove(index)"
                              >{{ $t('iftttset.downmove') }}</el-button>
                            </span>
                            <el-button
                              type="text"
                              class="ifttt_mod_button"
                              @click="modifyDeviceAction(action)"
                            >
                              <i class="icon-21" />
                            </el-button>
                            <el-button
                              type="text"
                              class="ifttt_del_button"
                              @click="delAction(index)"
                            >
                              <i class="icon--1" />
                            </el-button>
                            <div v-if="action.ActionList != null && action.IsDel != true" class="scence_box_action">
                              <op-action-container
                                :web-container="allUIConfig?.[action?.ClassSku]?.webContainer"
                                :action-list="action.ActionList"
                                :show-mode="APP_SHOW_MODE_ENUM.IFTTT"
                                :all-action-list="action.allActionlist"
                                :is-visual="isVisual"
                              >
                                <template #action="{ item:actionItem }">
                                  <control-item
                                    :tip-type="2"
                                    :v-device-id="action.VDeviceId"
                                    :action-info="actionItem.actionInfo"
                                    :show-button="false" 
                                    :is-i-f-t-t="true" 
                                    :PlanId="handleTianMuInIfttt({ActionList:action.ActionList,VDeviceId: action.VDeviceId}).toString()"
                                    :device-model="action"
                                    :show-mode="APP_SHOW_MODE_ENUM.IFTTT"
                                    :is-edit-video-scene="isEditVideoScene"
                                    :only-scene-no-list="true"
                                    :selected-scene-no="selectedSceneNo"
                                    @do-call-action-middle="(...arg) => { doCallActionClassSku(actionItem.actionInfo, ...arg) }"
                                  />
                                </template>
                              </op-action-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else-if="action.ActionType == 6">
                      <div
                        :key="'infoaction-' + index"
                        class="custom_right_line clearfix"
                      >
                        <div class="triggle_block clearfix">
                          <div class="triggle_left">
                            <div
                              class="triggle_title"
                              style="overflow: unset;"
                            >
                              <span>{{ index + 1 }}</span>
                              <em />
                              {{ $t('iftttset.do1') }} {{ $t('iftttset.areacontrol') }} {{ action.AreaName }} {{ action.IsDel?'-'+$t('iftttset.alreadydelete'):'' }}
                            </div>
                            <span class="button_remove">
                              <el-button
                                :disabled="index==0"
                                @click="upmove(index)"
                              >{{ $t('iftttset.upmove') }}</el-button>
                              <el-button
                                :disabled="index+1==allactionlist.length"
                                @click="downmove(index)"
                              >{{ $t('iftttset.downmove') }}</el-button>
                            </span>
                            <el-button
                              type="text"
                              class="ifttt_mod_button"
                              @click="modifyAreaAction(action)"
                            >
                              <i class="icon-21" />
                            </el-button>
                            <el-button
                              type="text"
                              class="ifttt_del_button"
                              @click="delAction(index)"
                            >
                              <i class="icon--1" />
                            </el-button>
                            
                            <div class="Ifttt_area-control ">
                              <agriculture-area-control 
                                v-if="$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture && action.showControlModeRadio === '2'"
                                :props-list="action.ActionList"
                                :is-i-f-t-t="true"
                                :is-show-flex="true"
                              />
                              <scene-card
                                v-if="$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture && action.showControlModeRadio === '1'"
                                :props-list="action.ActionList"
                                :is-i-f-t-t="true"
                              />

                              <scene-card
                                v-if="$store.state.projectinfor.ProjectType !== PROJECTTYPE_ENUM.Agriculture"
                                :props-list="action.ActionList"
                                :is-i-f-t-t="true"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        :key="'infoscene-' + index"
                        class="custom_right_line clearfix"
                      >
                        <template v-if="action.ActionType==4">
                          <span>{{ index + 1 }}</span>
                          <em />
                          <span>
                            {{ $t('iftttset.do1') }} {{ $t('iftttset.scene') }}
                            <span
                              class="scene-link"
                              :class="{ 'is-disabled': action.IsDel || !action.SceneNo || action.AutoTemplateParams?.DataContent?.isCanEdit === false }"
                              @click="openSceneDetail(action)"
                            >{{ action.SceneName }}</span>{{ action.IsDel?'-'+$t('iftttset.alreadydelete'):'' }}
                          </span>
                        </template>
                        <template v-if="action.ActionType==7">
                          <span>{{ index + 1 }}</span>
                          <em />
                          <span>{{ $t('iftttset.do1') }} {{ $t('iftttset.ifttt') }} {{ action.IFT_Name }}{{ action.IsDel?'-'+$t('iftttset.alreadydelete'):'' }}</span>
                        </template>
                        <template v-if="action.ActionType==3">
                          <span>{{ index + 1 }}</span>
                          <em />
                          <span>{{ $t('iftttset.do1') }}{{ $t('iftttset.switchifttt') }} {{ action.IFT_Name }}{{ action.IsDel?'-'+$t('iftttset.alreadydelete'):'' }}</span>
                          <div class="switch_box">
                            <el-switch
                              v-model="action.IsEnable"
                              active-color="#7dacee"
                              inactive-color="#d9e2f0"
                            />
                          </div>
                          <div v-if="iftttReverseDelayTime[action.IFT_ID] && Object.keys(iftttReverseDelayTime[action.IFT_ID]).length > 0">
                            {{ automaticalTurnOnOff( (iftttReverseDelayTime[action.IFT_ID].hour ? `${iftttReverseDelayTime[action.IFT_ID].hour}${$t('monitor.onehour')}` : '') +
                              (iftttReverseDelayTime[action.IFT_ID].minute ? `${iftttReverseDelayTime[action.IFT_ID].minute}${$t('ifttt.minute')}` : '') +
                              (iftttReverseDelayTime[action.IFT_ID].second ? `${iftttReverseDelayTime[action.IFT_ID].second}${$t('iftttset.second')}` : ''),action.IsEnable ? $t('scene.close') : $t('scene.open')) }}
                          </div>
                        </template>
                        <template v-if="action.ActionType==8">
                          <span>{{ index + 1 }}</span>
                          <em />
                          <span>{{ $t('iftttset.do1') }} {{ $t('iftttset.switchifttt') }} {{ action.HCLName }}{{ action.IsDel?'-'+$t('iftttset.alreadydelete'):'' }}</span>
                          <div class="switch_box">
                            <el-switch
                              v-model="action.IsEnable"
                              active-color="#7dacee"
                              inactive-color="#d9e2f0"
                            />
                          </div>
                        </template>
                        <template v-if="action.ActionType==1">
                          <span>{{ index + 1 }}</span>
                          <em />
                          <span v-if="action.time.split(':')[0]=='00' && action.time.split(':')[1]=='00'">{{ $t('iftttset.delay') }} {{ action.time.split(':')[2] }} {{ $t('iftttset.second') }}</span>
                          <span v-else>{{ $t('iftttset.delay') }} {{ action.time.split(':')[0] }} {{ $t('iftttset.hour') }} {{ action.time.split(':')[1] }} {{ $t('iftttset.minutes') }} {{ action.time.split(':')[2] }} {{ $t('iftttset.second') }}</span>
                        </template>
                        <span class="button_remove">
                          <el-button
                            :disabled="index==0"
                            @click="upmove(index)"
                          >{{ $t('iftttset.upmove') }}</el-button>
                          <el-button
                            :disabled="index+1==allactionlist.length"
                            @click="downmove(index)"
                          >{{ $t('iftttset.downmove') }}</el-button>
                        </span>
                        <el-button
                          v-if="action.ActionType==1"
                          type="text"
                          class="ifttt_mod_button"
                          @click="modifyTimeAction(action)"
                        >
                          <i class="icon-21" />
                        </el-button>
                        <el-button
                          v-if="$store.state.isNoLimit && action.ActionType==3"
                          type="text"
                          class="ifttt_mod_button"
                          @click="modifyallList('action', 'z', action, index)"
                        >
                          <i class="icon-21" />
                        </el-button>
                        <el-button
                          type="text"
                          class="ifttt_del_button"
                          @click="delallList(index)"
                        >
                          <i class="icon--1" />
                        </el-button>
                      </div>
                    </template>
                  </template>

                  <el-dropdown
                    v-if="actionObjAdddataShow()"
                    trigger="click"
                    class="dialog_add text-button"
                    @command="handleAddSet"
                  >
                    <span class="el-dropdown-link">
                      {{ $t('iftttset.adddata') }}
                      <i class="el-icon-arrow-down el-icon--right" />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(item, index) in optionsAdd"
                        :key="index"
                        :command="item.value"
                      >
                        {{ item.label }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <span
                    v-if="actionObjAdddataShow()!=true"
                    class="warmfont warmTips"
                  >{{ actionObjAdddataShowTips() }}</span>
                </div>
              </div>
              <IftttOptionTime 
                v-if="!(triggermanual && triggermanual.length > 0)"
                ref="iftttOptionTime" 
                :page-type="pageType" 
                :init-data="optionTimeData"
                :init-panel-data="initPanelData"
                :trigger-manual="triggermanual && triggermanual.length > 0"
                :is-triggle="isTriggle"
                :is-action="isAction"
              />
            </div>
          </template>
          <div
            v-if="!noSave"
            class="custom_button"
            :style="{
              position: 'fixed',
              padding: '0 20px',
              width: 'auto',
              background: 'white',
              bordertop: '1px solid rgb(255, 255, 255)',
              right: '41px',
              border: 'solid 1px #e1e5e7',
              borderRadius: '5px',
              bottom: '5px',
              margin: 0,
              'z-index': '1001',
            }"
          >
            <el-button
              class="blueButton"
              :loading="isloading"
              style="margin: 20px 0;"
              @click="saveIfttt"
            >
              {{ $t('iftttset.save') }}
            </el-button>
            &nbsp;<button
              class="lineButton fright"
              style="margin: 20px 0;"
              @click="cancle"
            >
              {{ $t('iftttset.back') }}
            </button>
            <!-- </div> -->
          </div>
        </vuescroll>
      </div>
    </div>
    <template v-if="timingset">
      <OppleTimerSettings
        :time-value="value1"
        :is-time-setting-visible="timingset"
        @onCancel="timingset = false;modifyItemClear()"
        @onOk="timeSettingOk"
      />
    </template>

    <template v-if="dialogSun">
      <IfftttSunDialog
        :visible="dialogSun"
        :init-data="sunOption"
        @close="dialogSun = false"
        @confirm="handleSunConfirm"
      />
    </template>

    <!-- 延时弹出 -->
    <template v-if="centerDialogVisible">
      <el-dialog
        :visible.sync="centerDialogVisible"
        class="timing"
        :modal-append-to-body="false"
        @close="modifyItemClear"
      >
        <div class="time_box">
          <i
            class="el-icon-close text-button"
            @click="centerDialogVisible = false"
          />
          <div class="blue_border">
            {{ blueTittle }}
          </div>
          <div
            class="time_cont clearfix"
            style="width: auto !important;text-align: center;"
          >
            <div style="display: inline-block;">
              <el-time-picker
                v-model="value1"
                :editable="true"
                class="timedata_input"
                format="HH"
                value-format="HH"
                popper-class="only_hour"
                :clearable="false"
              />
              <em class="time_text">{{ $t('iftttset.hour') }}</em>
              <el-time-picker
                v-model="value2"
                :editable="true"
                class="timedata_input"
                format="mm"
                value-format="mm"
                popper-class="only_minute"
                :clearable="false"
              />
              <em class="time_text">{{ $t('iftttset.minutes') }}</em>
              <el-time-picker
                v-model="value3"
                :editable="true"
                class="timedata_input"
                format="ss"
                value-format="ss"
                popper-class="only_second"
                :clearable="false"
              />
              <em class="time_text">{{ $t('iftttset.second') }}</em>
            </div>
          </div>

          <span
            slot="footer"
            class="dialog-footer"
          >
            <button
              class="blueButton"
              type="primary"
              @click="delayTimeAdd();modifyItemClear();"
            >{{ $t('iftttset.sure') }}</button>
            <button
              class="lightButton"
              @click="cancledelayTime();modifyItemClear();"
            >{{ $t('iftttset.cancle') }}</button>
          </span>
        </div>
      </el-dialog>
    </template>

    <!-- triggle选择设备弹出 -->
    <template v-if="dialogGroup">
      <IfftttDeviceDialog
        :key="''"
        :is_group="false"
        :visible="dialogGroup"
        :gp-no="parameters.GpNo"
        :area-tree-type="1"
        :execute-type="1"
        :displaynoarea="true"
        :is-need-same-device-status="2"
        :checkeddata="deviceOption"
        :is-visual="isVisual"
        :multiple-dialog-group="multipleDialogGroup"
        @change="confirmTrigger"
        @close="hidenDeviceDialogDialog"
        @chooseDeviceInMap="chooseDeviceInMap"
      />
    </template>
    <!-- Action选择设备弹出 -->
    <template v-if="dialogAction">
      <IfftttDeviceDialog
        :key="''"
        :is_group="false"
        :visible="dialogAction"
        :gp-no="parameters.GpNo"
        :area-tree-type="1"
        :execute-type="2"
        :displaynoarea="true"
        :is-need-same-device-status="2"
        :checkeddata="allactionlist"
        :multiple-dialog-group="true"
        :is-ifttt="true"
        :is-visual="isVisual"
        @change="confirmaction"
        @close="hidenDeviceDialogDialog"
        @chooseDeviceInMap="chooseDeviceInMap"
      />
    </template>
    <!-- 选择场景弹出 -->
    <template v-if="dialogVisible">
      <el-dialog
        :visible.sync="dialogVisible"
        class="dialogGroup choose_device"
        :before-close="handleClose"
        :modal-append-to-body="false"
      >
        <v-scence
          :areaid="parameters.GpNo"
          :already-check="allactionlist"
          :nocall="true"
          @confirm="confirmScene"
        />
      </el-dialog>
    </template>
    <!-- 选择开关自动化 -->
    <template v-if="dialogIfttt2">
      <el-dialog
        :visible.sync="dialogIfttt2"
        class="dialogGroup choose_device dialogIfttt"
        :before-close="handleClose"
        :modal-append-to-body="false"
      >
        <v-ifttt
          :areaid="parameters.GpNo"
          :searchtype="1"
          :already-check="allactionlist"
          :switch-show="false"
          :iftttmodel="iftttmodel"
          @confirm="confirmIfttt"
        />
      </el-dialog>
    </template>
    <!-- 选择手动自动化 -->
    <template v-if="dialogIfttt">
      <el-dialog
        :visible.sync="dialogIfttt"
        class="dialogGroup choose_device dialogIfttt"
        :before-close="handleClose"
        :modal-append-to-body="false"
      >
        <v-ifttt
          :areaid="parameters.GpNo"
          :searchtype="2"
          @confirm="confirmIfttthandle"
        />
      </el-dialog>
    </template>
    <!-- 选择节律 -->
    <template v-if="dialogHcl">
      <el-dialog
        :visible.sync="dialogHcl"
        class="dialogGroup choose_device dialogIfttt"
        :before-close="handleClose"
        :modal-append-to-body="false"
      >
        <v-hcl
          :areaid="parameters.GpNo"
          :searchtype="2"
          :switch-show="false"
          @confirm="confirmHclhandle"
        />
      </el-dialog>
    </template>
    <!-- areaSelect选择区域弹出 -->
    <template v-if="dialogAreaSelect">
      <el-dialog
        class="remove_tree_cont"
        :visible.sync="dialogAreaSelect"
        width="650px"
        :before-close="handleClose"
        :modal-append-to-body="false"
      >
        <div class="remove_tree">
          <div class="blue_header dialog_title">
            <span>{{ $t('monitor.selectdevicearea') }}</span>
          </div>
          <i
            class="el-icon-close text-button"
            @click="dialogAreaSelect=false"
          />
          <select-area
            :checkedarea="tempareacheckedarea"
            class="limit_set"
            :only-select-one="false"
            :areaid="parameters.GpNo"
            :area-self="true"
            @getarealist="getarealist"
          />
          <div
            class="limite_button"
            @click="areaselectfinsh"
          >
            {{ $t('install.finsh') }}
          </div>
        </div>
      </el-dialog>
    </template>

    <template v-if="triggle">
      <el-dialog
        :visible.sync="triggle"
        class=" dialogTriggle triggle_device"
        :before-close="handleClose"
        :modal-append-to-body="false"
        @close="cancel();modifyItemClear();"
      >
        <div class="triggle_cont">
          <div class="blue_border">
            {{ $t('iftttset.triggerset') }}
          </div>
          <div class="triggle_button_box">
            <vuescroll>
              <div class="triggle_scl de_triggle_scl">
                <div
                  v-for="(item, index) in triggleaction"
                  :key="index"
                  class="triggle_list"
                  :class="{ triggle_cur: multipleCur.indexOf(index)>=0, eventNone: item['enable'], grayImage: item['enable']}"
                  :style="item['enable']?'opacity: 0.2;':''"
                  @click="checkRadio(item, index)"
                >
                  <div
                    v-if="item['UI'].disable !== 1"
                    class="triggle_line clearfix"
                  >
                    <em class="triggle_one" />
                    <span class="triggle_span">{{ item.Desc }}</span>
                    <div class="triggle_left" @click.stop="stopCheckRadio(item, index)">
                      <div
                        v-if="item.ValueType == 'UIControl_Switch'"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <el-switch
                              v-model="item.DefaultValue"
                              active-color="#7dacee"
                              inactive-color="#d9e2f0"
                              :active-value="1"
                              :inactive-value="0"
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="item.ValueType == 'UIControl_Slider' && item.OperationValue !== 8"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <div class="triggle_no_img">
                              <div class="triggle_slider pr_6">
                                <el-slider
                                  v-model="item.DefaultValue"
                                  :min="item.Min"
                                  :max="item.Max"
                                />
                              </div>
                              <!-- <span class="triggle_input">{{ item.DefaultValue }}</span> -->
                              <el-input-number
                                v-model="item.DefaultValue"
                                class="input_number_action"
                                :min="item.Min"
                                :max="item.Max"
                                style="width: 40px;height:24px;"
                              />
                              <span
                                v-if="item.ParaUnit"
                                class="triggle_para_unit"
                              >{{ item.ParaUnit }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="item.ValueType == 'UIControl_Slider' && item.OperationValue === 8"
                        class="triggle_div triggle_div_group"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">&lt;</span>
                          <div class="triggle_div2">
                            <div class="triggle_no_img">
                              <div class="triggle_slider pr_6">
                                <el-slider
                                  v-model="item.DefaultValue[0]"
                                  :min="item.Min"
                                  :max="item.DefaultValue[1]"
                                />
                              </div>
                              <el-input-number
                                v-model="item.DefaultValue[0]"
                                class="input_number_action"
                                :min="item.Min"
                                :max="item.DefaultValue[1]"
                                style="width: 40px;height:24px;"
                              />
                              <span
                                v-if="item.ParaUnit"
                                class="triggle_para_unit"
                              >{{ item.ParaUnit }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="option_title_middle">
                          {{ $t('iftttset.or') }}<span>></span>
                        </div>
                        <div class="triggle_ctr ">
                          <div class="triggle_div2">
                            <div class="triggle_no_img">
                              <div class="triggle_slider pr_6">
                                <el-slider
                                  v-model="item.DefaultValue[1]"
                                  :min="item.DefaultValue[0]"
                                  :max="item.Max"
                                />
                              </div>
                              <el-input-number
                                v-model="item.DefaultValue[1]"
                                class="input_number_action"
                                :min="item.DefaultValue[0]"
                                :max="item.Max"
                                style="width: 40px;height:24px;"
                              />
                              <span
                                v-if="item.ParaUnit"
                                class="triggle_para_unit"
                              >{{ item.ParaUnit }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="item.ValueType == 'UIControl_RadioboxList'"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <el-radio
                              v-for="(smodel) in item.EnumValue"
                              :key="'D' + smodel.Value"
                              v-model="item.DefaultValue"
                              :label="smodel.Value"
                            >
                              {{ smodel.Name }}
                            </el-radio>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="item.ValueType == 'UIControl_ChooseRange'"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <div class="triggle_no_img rang_slider">
                              <div
                                class="triggle_slider"
                                style="width: 120px!important;"
                              >
                                <el-slider
                                  v-if="fileSizeShow"
                                  v-model="item.DefaultValue"
                                  :min="item.Min"
                                  range
                                  :max="item.Max"
                                  style="width:110px"
                                />
                              </div>
                              <!-- <span class="triggle_input">{{ item.DefaultValue[0] }}-{{item.DefaultValue[1]}}</span> -->
                              <div
                                class="triggle_range_inputs"
                                style="display: inline-block;float: right;margin-right: 9px;"
                              >
                                <el-input-number
                                  v-model="item.DefaultValue[0]"
                                  class="input_number_action"
                                  :min="item.Min"
                                  :max="item.Max"
                                  style="width: 40px;height:24px;"
                                  @change="doUIControlChooseRangeChange"
                                />
                                <span class="triggle_range_sep">-</span>
                                <el-input-number
                                  v-model="item.DefaultValue[1]"
                                  class="input_number_action"
                                  :min="item.Min"
                                  :max="item.Max"
                                  style="width: 40px;height:24px;"
                                  @change="doUIControlChooseRangeChange($event,item, 'DefaultValue', 1)"
                                />
                                <span
                                  v-if="item.ParaUnit"
                                  class="triggle_para_unit"
                                >{{ item.ParaUnit }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="item.ValueType == 'UIControl_DropdownList'"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <el-select
                              v-model="item.DefaultValue"
                              :placeholder="$t('install.choose')"
                              class="input_set"
                            >
                              <el-option
                                v-for="(smodel) in item.EnumValue"
                                :key="'Ctrigger' + smodel.Value"
                                :label="smodel.Name"
                                :value="smodel.Value"
                              />
                            </el-select>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="item.ValueType == 'UIControl_ColorTemperature'"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <img
                              class="triggle_img1"
                              src="../../assets/img/icon_set-01.png"
                            >
                            <div class="triggle_slider">
                              <el-slider
                                v-model="item.DefaultValue"
                                :min="item.Min"
                                :max="item.Max"
                                class="color_add"
                              />
                            </div>
                            <img
                              class="triggle_img2"
                              src="../../assets/img/icon_set-02.png"
                            >
                            <!-- <span class="triggle_input">{{ item.DefaultValue }}</span> -->
                            <el-input-number
                              v-model="item.DefaultValue"
                              class="input_number_action"
                              :min="item.Min"
                              :max="item.Max"
                              style="width: 40px;height:24px;"
                            />
                            <span
                              v-if="item.ParaUnit"
                              class="triggle_para_unit"
                            >{{ item.ParaUnit }}</span>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="item.ValueType == 'UIControl_Bright'"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <img
                              class="triggle_img1"
                              src="../../assets/img/icon_set-03.png"
                            >
                            <div class="triggle_slider">
                              <el-slider
                                v-model="item.DefaultValue"
                                :min="item.Min"
                                :max="item.Max"
                                class="light_add"
                              />
                            </div>
                            <img
                              class="triggle_img2"
                              src="../../assets/img/icon_set-04.png"
                            >
                            <!-- <span class="triggle_input">{{ item.DefaultValue }}</span> -->
                            <el-input-number
                              v-model="item.DefaultValue"
                              class="input_number_action"
                              :min="item.Min"
                              :max="item.Max"
                              style="width: 40px;height:24px;"
                            />
                            <span
                              v-if="item.ParaUnit"
                              class="triggle_para_unit"
                            >{{ item.ParaUnit }}</span>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="item.ValueType == 'UIControl_SliderAndInput'"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <div class=" triggle_have_input">
                              <div class="triggle_slider ">
                                <span
                                  v-if="item.MsgID != null && item.MsgID.indexOf('0x03')!=-1"
                                  class="lightUnit lingthUnit_slider"
                                >%</span>
                                <el-slider
                                  v-model="item.DefaultValue"
                                  :min="item.Min"
                                  :max="item.Max"
                                  show-input
                                  :show-input-controls="false"
                                  @change="dataFormatInt(false, model,'DefaultValue', model,'Type','0x03');"
                                />
                              </div>
                              <span
                                v-if="item.ParaUnit"
                                class="triggle_para_unit"
                              >{{ item.ParaUnit }}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="item.ValueType == 'UIControl_MultipleDropdownList'"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <el-select
                              v-model="item.DefaultValue"
                              :placeholder="$t('install.choose')"
                              class="input_set"
                              multiple
                              collapse-tags
                            >
                              <el-option
                                v-for="(smodel) in item.EnumValue"
                                :key="'Ctriggers' + smodel.Value"
                                :label="smodel.Name"
                                :value="smodel.Value"
                              />
                            </el-select>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="item.ValueType == 'UIControl_CheckboxList'"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <el-checkbox-group v-model="item.DefaultValue">
                              <el-checkbox
                                v-for="(smodel) in item.EnumValue"
                                :key="'Fx' + smodel.Value"
                                :label="smodel.Value"
                              >
                                {{ smodel.Name }}
                              </el-checkbox>
                            </el-checkbox-group>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="item.ValueType == 'UIControl_StartAndStop'"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <button class="warm_button warm_button_left statr_button">
                              <i class="icon-141" />
                              {{ $t('deviceMsg.stop') }}
                            </button>
                            <button class="warm_button statr_button">
                              <i class="icon-10" />
                              {{ $t('deviceMsg.start') }}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="item.ValueType == 'UIControl_Motor_Stop'"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <button class="warm_button warm_button_left statr_button">
                              <i class="icon-141" />
                              {{ $t('deviceMsg.stop') }}
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="item.ValueType == 'UIControl_Input'"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <input
                              v-model="item.DefaultValue"
                              class="triggle_input_set"
                            >
                            <span
                              v-if="item.ParaUnit"
                              class="triggle_para_unit"
                            >{{ item.ParaUnit }}</span>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="item.ValueType == 'UIControl_MotorTrace_Slider' || item.ValueType == 'UIControl_MotorVerticalTrace_Slider'"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <img
                              class="triggle_img1"
                              src="../../assets/img/icon_set-06.png"
                            >
                            <div class="triggle_slider">
                              <el-slider
                                v-model="item.DefaultValue"
                                :min="item.Min"
                                :max="item.Max"
                              />
                            </div>
                            <img
                              class="triggle_img2"
                              src="../../assets/img/icon_set-05.png"
                            >
                            <span class="triggle_input">{{ item.DefaultValue }}%</span>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="item.ValueType == 'UIControl_MotorAngle_Slider'"
                        class="triggle_div"
                      >
                        <div class="triggle_ctr ">
                          <span class="triggle_span2">{{ item.OperationName }}</span>
                          <div class="triggle_div2">
                            <img
                              class="triggle_img1"
                              src="../../assets/img/icon_set-07.png"
                            >
                            <div class="triggle_slider">
                              <el-slider
                                v-model="item.DefaultValue"
                                :min="item.Min"
                                :max="item.Max"
                              />
                              <span class="angle_span1">{{ $t('iftttset.up') }}</span>
                              <span class="angle_span2">{{ $t('iftttset.down') }}</span>
                            </div>
                            <img
                              class="triggle_img2"
                              src="../../assets/img/icon_set-08.png"
                            >
                            <span class="triggle_input">{{ item.DefaultValue }}°</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </vuescroll>

            <div class="trigger_two">
              <button
                class="fleft blueButton"
                @click="okTrigger();modifyItemClear();"
              >
                {{ $t('iftttset.sure') }}
              </button>
              <button
                class="fright"
                @click="cancel();modifyItemClear();"
              >
                {{ $t('iftttset.cancle') }}
              </button>
            </div>
          </div>
        </div>
      </el-dialog>
    </template>

    <!-- 设备action能力 -->
    <template v-if="actionPannel">
      <el-dialog
        :visible.sync="actionPannel"
        class=" dialogTriggle test"
        :before-close="handleClose"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        @close="modifyItemClear"
      >
        <div class="triggle_cont">
          <div class="blue_border">
            {{ $t('iftttset.actionset') }}
          </div>
          <div class="triggle_button_box">
            <vuescroll>
              <div class="triggle_scl de_triggle_scl action_dialog_main">
                <op-action-container :web-container="allUIConfig?.[temdevice?.ClassSku]?.webContainer" :action-list="actionlist" :show-mode="APP_SHOW_MODE_ENUM.IFTTT">
                  <template #action="{ item }">
                    <control-item
                      :tip-type="2"
                      :gp-details="gpDetails"
                      :action-list="actionlist"
                      :action-info="item.actionInfo"
                      :show-button="false" 
                      :is-i-f-t-t="true" 
                      :show-check-box="true"
                      :PlanId="iftttPlantId"
                      :device-model="temdevice"
                      :show-mode="APP_SHOW_MODE_ENUM.IFTTT"
                      @changeCheckBox="checkRadioAction(item.actionInfo)"
                    />
                  </template>
                </op-action-container>
              </div>
            </vuescroll>
            <div class="trigger_two">
              <button
                class="fleft blueButton"
                @click="okaction();"
              >
                {{ $t('iftttset.sure') }}
              </button>
              <button
                class="fright"
                @click="cancel();modifyItemClear();"
              >
                {{ $t('iftttset.cancle') }}
              </button>
            </div>
          </div>
        </div>
      </el-dialog>
    </template>
    <template v-if="tempareaactionPannel">
      <el-dialog
        :visible.sync="tempareaactionPannel"
        class="dialogTriggle tempAreaPannel "
        :width="'650px'"
        :before-close="handleClose"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        @close="modifyItemClear"
      >
        <div
          class="triggle_cont"
          style="width: 610px;" 
        >
          <div class="blue_border">
            {{ $t('iftttset.areacontrol') }}
          </div>
          <div class="triggle_button_box">
            <vuescroll>
              <div class="triggle_scl de_triggle_scl area_control">
                <el-radio v-if="$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture" v-model="controlModeRadio" label="1">
                  {{ $t('scene.masterControl') }}
                </el-radio>
                <el-radio v-if="$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture" v-model="controlModeRadio" label="2">
                  {{ $t('scene.partialControl') }}
                </el-radio>
                <agriculture-area-control 
                  v-if="$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture && controlModeRadio === '2'" 
                  :props-list="filteredAreaControlActionList"
                  :show-check-box="true"
                  :is-i-f-t-t="true"
                />
                <scene-card
                  v-if="$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture && controlModeRadio === '1'"
                  :props-list="filteredAreaControlActionList"
                  :show-check-box="true"
                  :is-i-f-t-t="true"
                />
                <scene-card
                  v-if="$store.state.projectinfor.ProjectType !== PROJECTTYPE_ENUM.Agriculture"
                  :props-list="filteredAreaControlActionList"
                  :show-check-box="true"
                  :is-i-f-t-t="true"
                />
              </div>
            </vuescroll>
            <div class="trigger_two">
              <button
                class="fleft blueButton"
                @click="addAreaAction();modifyItemClear();"
              >
                {{ $t('iftttset.sure') }}
              </button>
              <button
                class="fright"
                @click="tempareaactionPannel = false;modifyItemClear();"
              >
                {{ $t('iftttset.cancle') }}
              </button>
            </div>
          </div>
        </div>
      </el-dialog>
    </template>
    <template v-if="SupportToggerVisible">
      <OppleModal
        :visible="SupportToggerVisible"
        :is-show-cancel-btn="false"
        :ok-text="ifttt3ToggerOkText"
        @onOk="toggerModalClose"
      >
        <i class="el-icon-info page_left_tip" />
        <span v-if="isSupportToggerflag">{{ $t('ifttt.needChangeGateway') }}</span>
        <span v-if="isSupportToggerflag2">{{ $t('ifttt.needUpdateGateway') }}</span>
      </OppleModal>
    </template>
    <template v-if="iftttReverseVisible">
      <el-dialog
        :visible.sync="iftttReverseVisible"
        class="timing"
        :modal-append-to-body="false"
        @close="modifyItemClear"
      >
        <div class="time_box automation_settings">
          <i
            class="el-icon-close text-button"
            @click="iftttReverseVisible = false"
          />
          <div class="blue_border">
            {{ $t('iftttset.automationSettings') }}
          </div>
          <div
            class="time_cont clearfix"
            style="width: auto !important;"
          >
            <div
              class="delay"
            >
              <el-checkbox v-model="iftttReverseDelayChecked">
                {{ $t('iftttset.toggleSettings') }}
              </el-checkbox>
              <div style="display: inline-block;">
                <el-time-picker
                  v-model="iftttReverseValue1"
                  :editable="true"
                  class="timedata_input"
                  format="HH"
                  value-format="HH"
                  popper-class="only_hour"
                  :clearable="false"
                />
                <em class="time_text">{{ $t('iftttset.hour') }}</em>
                <el-time-picker
                  v-model="iftttReverseValue2"
                  :editable="true"
                  class="timedata_input"
                  format="mm"
                  value-format="mm"
                  popper-class="only_minute"
                  :clearable="false"
                />
                <em class="time_text">{{ $t('iftttset.minutes') }}</em>
                <el-time-picker
                  v-model="iftttReverseValue3"
                  :editable="true"
                  class="timedata_input"
                  format="ss"
                  value-format="ss"
                  popper-class="only_second"
                  :clearable="false"
                />
                <em class="time_text">{{ $t('iftttset.second') }}</em>
              </div>
            </div>
          </div>

          <span
            slot="footer"
            class="dialog-footer"
          >
            <button
              class="blueButton"
              type="primary"
              @click="iftttReverseDelay();modifyItemClear()"
            >{{ $t('iftttset.sure') }}</button>
            <button
              class="lightButton"
              @click="iftttReverseVisible=false;modifyItemClear()"
            >{{ $t('iftttset.cancle') }}</button>
          </span>
        </div>
      </el-dialog>
    </template>
    <el-dialog
      class="otaWarn_box"
      width="860px"
      :before-close="handleUpdateClose"
      :visible.sync="otaWarnFlag"
      :modal-append-to-body="false"
    >
      <otaUpdateDidalog 
        :move-type="2"
        :title="titleText"
        :app-update-is-show="false"
        :web-update-is-show="webUpdateIsShow"
        :ota-update-is-show="otaUpdateIsShow"
        :new-device-selected="newDeviceSelected"
        :ota-gateway-support="otaGatewaySupportShow"
        :ota-gateway-support-list="OtaDeviceSupportList"
        :scene-ota="true"
        @closeDialog="setOtaWarnFlag" 
      />
    </el-dialog>

    <OpDialog
      class="opple-scene-action-dialog"
      :visible="TianmuIsShow"
      :is-show-btn="false"
      @onClose="handleTianmuClose"
    >
      <IftttTianmuVideo
        v-if="TianmuIsShow"
        :show-mode="APP_SHOW_MODE_ENUM.IFTTT"
        :TianmuVideoSceneNo="TianmuVideoSceneNo"
        :only-scene-no-list="true"
        :actionlist="actionlist"
        :web-container="allUIConfig?.[temdevice?.ClassSku]?.webContainer"
        @setSceneVideoDevice="setSceneVideoDevice"
        @sceneVideoConfirm="sceneVideoConfirm"
      />
    </OpDialog>
  </div>
</template>

<script>
import mainMixins from './mixins/main';
import freeMixins from './mixins/free';
import tianmuMixins from './mixins/tianmu';
import actionMixins from './mixins/actions';
import areaMixins from './mixins/area';
import triggerMixins from './mixins/triggers';
import timeMixins from './mixins/time';
import ifttt3 from './mixins/ifttt3';
import ifttt4 from './mixins/ifttt4';

export default {
  components: {
  },
  mixins: [ifttt4, mainMixins, freeMixins, tianmuMixins, actionMixins, areaMixins, triggerMixins, timeMixins, ifttt3]
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/action.scss";
.scene-link {
  float: none;
  display: inline;
  color: #409eff;
  cursor: pointer;
}

.scene-link.is-disabled {
  color: inherit;
  cursor: default;
}

.triggle_cont{
  width: 100%;
}
.triggle_line{
  display:flex;
}
.triggle_line .triggle_span{
  width:auto;
  white-space: nowrap;
  min-width: 83px;
}
.dialog_add {
  color: #111111;
}
.color-item{
  float: left;
  margin-right: 10px;
  margin-bottom: 10px;
}
.triggle_ctr{
  display: flex;
  align-items: center;
}
.triggle_div2{
  width: auto;
  min-width: 300px;
  .triggle_switch{
    margin-right: 40px;
  }
  .triggle_switch2{
    margin-left: 40px;
  }
  .triggle_switch_ml20{
    margin-left: 20px;
  }

}
.triggle_span2{
  width: auto;
  min-width: 80px;
  overflow: hidden;
  white-space: nowrap; /* 防止文本换行 */
  text-overflow: ellipsis; /* 显示省略号 */
}
.triggle_span_middle{
  margin-left: -40px;
}
.triggle_para_unit {
  margin-left: 6px;
  color: #909399;
  font-size: 12px;
  height: 24px;
  line-height: 24px;
  white-space: nowrap;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
.triggle_range_inputs {
  white-space: nowrap;
}
.triggle_range_sep {
  margin: 0 4px;
  vertical-align: middle;
}

/*
 * 本页仅覆盖：去掉 line-height/margin 硬凑，补齐垂直居中与单位不换行。
 * 不改动滑条原有宽度计算（保持布局与原来一致）。
 */
.custom_right.custom_set .custom_right_line {
  .triggle_ctr {
    align-items: center;
  }

  .triggle_div .triggle_div2,
  .triggle_div2 {
    line-height: normal;
    margin-top: 0;
  }

  .triggle_div .triggle_div2 .triggle_slider,
  .triggle_div2 .triggle_slider {
    margin-top: 0 !important;
  }

  .triggle_div .triggle_input,
  .triggle_input {
    white-space: nowrap;
    line-height: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
  }

  .triggle_para_unit {
    vertical-align: middle;
  }
}

::v-deep .custom_right.custom_set .custom_right_line {
  .el-slider__runway {
    margin-top: 0;
    margin-bottom: 0;
  }

  .el-input-number {
    height: 24px;
    line-height: 24px;
    vertical-align: middle;

    .el-input__inner {
      height: 24px;
      line-height: 24px;
    }
  }
}
.out_bread {
  border: solid 1px #eceef1;
  background-color: #fdfdfe;
  .customset {
    padding: 0 32px;
    height: 100%;
    .custom_button {
      button {
        border: solid 1px #a6a6a6;
        border-radius: 3px;
        color: #525252;
        background: #ffffff;
      }
      .lineButton {
        &:hover {
          border-color: #0046aa;
          color: #ffffff;
          background-color: #0046aa;
        }
      }
      .blueButton {
        border-color: #0046aa;
        color: #ffffff;
        background-color: #0046aa;
      }
    }
    .custom_border {
      border: solid 1px #e0e3e6;
      .custom_add {
        margin-bottom: 40px;
        font-size: 14px;
        text-indent: 10px;
      }
      .custom_line {
        .custom_left {
          display: inline-block;
          color: #1d1d1d;
          .dot_num {
            display: inline-block;
            width: 23px;
            height: 23px;
            border-radius: 50%;
            text-indent: 6px;
            color: #ffffff;
            background-color: #439af3;
            font-style: italic;
            line-height: 23px;
          }
        }
        .custom_right {
          display: inline-block;
          float: right;
          line-height: 49px;
          .custom_right_line {
            position: relative;
            margin-right: 40px;
            border-bottom: dashed 1px #d6dce1;
            line-height: 49px;
            span {
              cursor: pointer;
            }
            em {
              display: inline-block;
              margin-right: 12px;
              margin-left: 4px;
              width: 5px;
              height: 5px;
              // color: #ebeef5;
              font-size: 10px;
              border-radius: 50%;
              text-indent: -16px;
              background-color: #717171;
              line-height: 5px;
            }
          }
        }
      }
    }
    .custom_base {
      padding: 8px 0 24px;
      span {
        display: inline-block;
        width: 116px;
        text-indent: 42px;
      }
      input {
        width: 363px;
        height: 40px;
        border: solid 1px #bdc5d3;
        text-indent: 8px;
        color: #101010;
      }
    }
    .blue_border {
      display: block;
    }
  }
}
.warm_button_select {
  color: #ffffff;
  background: #619df1;
}
.dataing_left .dataing_interval {
  margin-bottom: 10px;
  padding-left: 10px;
}
.custom_button {
  .blueButton {
    width: unset;
    min-width: 98px;
    height: 35px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 3px;
    color: rgb(255 255 255 / 100%);
    background: rgb(0 70 170 / 100%);
  }
  .lineButton {
    margin-left: 34px;
    width: 98px;
    height: 35px;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid rgb(212 216 223 / 100%);
    border-radius: 3px;
  }
}
.warmTips {
  font-size: 14px;
  font-weight: 500;
}
.triggle_div_group{
  display: flex;   
  align-items: center; 
  margin-bottom: 16px;
  margin-left: 10px;
  min-height: 42px;
  .option_title_middle{
    margin-left: 10px;
    display: flex;
    span{
      margin-left: 10px;
    }
  }
}
.pr_6{
  padding-right: 6px;
}
.triggle_device .el-dialog{
  width: 1132px;
}
.tempAreaPannel ::v-deep .el-dialog__body{
  padding: 10px 20px 30px !important;
}
.tempAreaPannel ::v-deep .el-dialog__header {
  padding: 20px 20px 10px !important;
  height: auto;
}
.tempAreaPannel ::v-deep .blue_border {
  display: inline-block !important;
}

.device_div_action_fill{
  width: 98%;
}
.triggle_more_action{
  // margin-top: 6px;
  float: none;
}
.triggle_more_action_hidden{
  visibility: hidden;
  
}
.triggle_left_action{
  width: calc(60% - 15px);
}
.triggle_left_action_fill{
  width: 100%
}
.action_dialog_main{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
}

.device_div_action{
  line-height: auto !important;
  align-items: baseline;
}
.action_dailog_line{
  display: flex;
  flex-direction: row;
  align-items: baseline
}

.area_control{
  padding-top:25px;
  ::v-deep .device_div_action{
    width: 97%;
  }
}


</style>
<style lang="scss">
.duv_add .el-slider__runway {
  background: linear-gradient(to right, #EF8A7F, #FAFCFE,#D8D8D8);
}
.duv_add .el-slider__bar {
  background-color: transparent;
}
.iftttNotice_options_time {
  display: flex;
  align-items: flex-start;
  padding: 40px 32px;

  .iftttNotice_option_right {
    cursor: pointer;
    width: 100%;
    padding-top: 5px;
  }
}

.el-dialog__wrapper.otaWarn_box .el-dialog {
  margin-top: 15vh!important;
}
.iftttreverse .opModal_body {
   height: 200px;
}
.switch{
  margin-left: 50px;
}
.delay{
  display: flex;
  align-items: center;
  margin-left: 50px;
}
.time_box.automation_settings{
  width: auto;
}

.opple-scene-action-dialog{
  width: 700px;
  min-height: auto;
  .opDialog_body{
    min-height: 280px !important;
  }
}
.ifttt-tianmu-container .other_action .device_div_action{
  width: 100%;
}
.ifttt-tianmu-container .active_joinTool{
   width: 100%!important;
}

.disable-interactive div,
.disable-interactive input,
.disable-interactive button,
.disable-interactive select,
.disable-interactive textarea,
.disable-interactive a,
.disable-interactive [role="button"],
.disable-interactive .clickable {
  pointer-events: none;
  opacity: 0.95;
  /* 可选：添加禁用样式 */
  background-color: #f5f5f5;
}
</style>
